import { api } from '../lib/api';

export interface CheckoutPayload {
  workspaceId: string;
  planId: string;
  billingCycle: 'monthly' | 'yearly';
  customerName: string;
  customerEmail: string;
  customerTaxId: string;
  customerCellphone: string;
}

export const abacatePayApi = {
  createCheckout: async (data: CheckoutPayload): Promise<{ url: string }> => {
    const response = await api.post('/abacatepay/checkout', data);
    return response.data;
  },

  cancelSubscription: async (workspaceId: string): Promise<{ success: boolean }> => {
    const response = await api.delete(`/abacatepay/cancel/${workspaceId}`);
    return response.data;
  },
};
